(function () {
    'use strict';

    angular
        .module('itemTaskModule', []);
})();